// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { bookingDestinationValues, businessTypeValues, contentStyleTemplateValues, depositAggregationValues, depositBasisValues, outroStyleValues, primaryCalendarTypeValues, servicePaymentPolicyValues, stylePreferenceValues } from '@borradh-workspace/labels';
/** Response atom for the "organization" table (1:1 with a DB row, on the wire). */
export const organizationAtomSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    logo: z.string().nullable(),
    googleReviewUrl: z.string().nullable(),
    businessType: z.enum(businessTypeValues),
    createdAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
    privacyErasedAt: z.string().datetime().nullable(),
    metadata: z.string().nullable(),
    apiKey: z.string().nullable(),
    websiteUrl: z.string().nullable(),
    facebookPageUrl: z.string().nullable(),
    privacyPolicyUrl: z.string().nullable(),
    termsUrl: z.string().nullable(),
    brandVoice: z.unknown().nullable(),
    targetAudienceDescription: z.string().nullable(),
    credibilityLine: z.string().nullable(),
    primaryColor: z.string().nullable(),
    secondaryColor: z.string().nullable(),
    backgroundColor: z.string().nullable(),
    brandFontImageUrl: z.string().nullable(),
    brandStyleGuide: z.string().nullable(),
    tagline: z.string().nullable(),
    address: z.string().nullable(),
    contentStyleTemplate: z.enum(contentStyleTemplateValues).nullable(),
    stylePreference: z.enum(stylePreferenceValues).nullable(),
    outroStyle: z.enum(outroStyleValues).nullable(),
    businessHours: z.unknown(),
    timezone: z.string(),
    videoCaptionColor: z.string().nullable(),
    videoCaptionFont: z.string().nullable(),
    videoCaptionPosition: z.string().nullable(),
    videoMusicVolume: z.number().nullable(),
    defaultBookingLink: z.string().nullable(),
    depositEnabled: z.boolean().nullable(),
    depositAmount: z.number().nullable(),
    defaultPaymentPolicy: z.enum(servicePaymentPolicyValues),
    defaultDepositBasis: z.enum(depositBasisValues),
    defaultDepositPercent: z.number().nullable(),
    depositAggregation: z.enum(depositAggregationValues),
    holdExpirationHours: z.number().nullable(),
    cancellationRescheduleDeadlineHours: z.number(),
    depositForfeitOnLateCancel: z.boolean(),
    depositForfeitOnNoShow: z.boolean(),
    customerReschedulingEnabled: z.boolean(),
    customerCancellationsEnabled: z.boolean(),
    emailRemindersEnabled: z.boolean(),
    smsRemindersEnabled: z.boolean(),
    bookingMinDaysAhead: z.number(),
    bookingMaxDaysAhead: z.number(),
    completedOnboardingTasks: z.unknown(),
    primaryCalendarType: z.enum(primaryCalendarTypeValues).nullable(),
    primaryCalendarAccountId: z.string().nullable(),
    bookingDestination: z.enum(bookingDestinationValues),
    defaultAppointmentDuration: z.number().nullable(),
    contributeToAggregateInsights: z.boolean(),
    stripeCustomerId: z.string().nullable(),
    chatbotSettings: z.unknown().nullable(),
    chatbotSystemPrompt: z.string().nullable(),
    claireBlockedAdCampaignIds: z.array(z.string()),
    knowledgeBase: z.unknown().nullable(),
    knowledgeBaseLastSyncedAt: z.string().datetime().nullable(),
    voiceStyleProfile: z.string().nullable(),
    voiceStyleProfileUpdatedAt: z.string().datetime().nullable(),
    isMock: z.boolean(),
});
//# sourceMappingURL=organization.js.map